/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeagueResponse } from './LeagueResponse';
import {
    LeagueResponseFromJSON,
    LeagueResponseFromJSONTyped,
    LeagueResponseToJSON,
    LeagueResponseToJSONTyped,
} from './LeagueResponse';

/**
 * 
 * @export
 * @interface GetLeagueResponse
 */
export interface GetLeagueResponse {
    /**
     * 
     * @type {LeagueResponse}
     * @memberof GetLeagueResponse
     */
    league: LeagueResponse;
}

/**
 * Check if a given object implements the GetLeagueResponse interface.
 */
export function instanceOfGetLeagueResponse(value: object): value is GetLeagueResponse {
    if (!('league' in value) || value['league'] === undefined) return false;
    return true;
}

export function GetLeagueResponseFromJSON(json: any): GetLeagueResponse {
    return GetLeagueResponseFromJSONTyped(json, false);
}

export function GetLeagueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeagueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'league': LeagueResponseFromJSON(json['league']),
    };
}

export function GetLeagueResponseToJSON(json: any): GetLeagueResponse {
    return GetLeagueResponseToJSONTyped(json, false);
}

export function GetLeagueResponseToJSONTyped(value?: GetLeagueResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'league': LeagueResponseToJSON(value['league']),
    };
}

